import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const exportNavReducer = foxGridReducer(
  gridNames.exportNav,
);

export default exportNavReducer;
